const UNIVERSAL = {
  // BASEURL: 'https://api.zocket.com',
  // LOGINURL:"https://x.zocket.com/prod/customer/auth/api/v1/login-with-password",
  BASEURL_1: "https://dev.zocket.com",
  BASEURL_2: "https://x.zocket.com/test/barath",
  // BASEURL_1: "https://api.zocket.com",
  // BASEURL_2: "https://x.zocket.com/prod/barath",
  // LOGINURL: "https://x.zocket.com/test/barath/auth/api/v1/login-with-password",
  // SIGNUP_URL: "https://x.zocket.com/test/barath/auth/api/v1/signup",
  // RESET_PASSWORD_URL: "https://x.zocket.com/test/barath/auth/api/v1/set-new-password-email",
  // WHATSAPP_VALIDATE:"https://x.zocket.com/test/barath/user/api/v1/business/whatsapp/validate",
  RAZORPAY_KEY_ID: "rzp_test_vHE4cfpoXYi5KE",
  RAZORPAY_SECRET: "cHC2fvf1Jo93bTvguMPBXJV9",
};

export default UNIVERSAL;
